import { colors } from "styles/colors";

// Hiring Status IDs
export const HIRING_STATUS_IDS = {
  APPLIED: 4,
  SHORTLISTED: 5,
  INTERVIEWED: 6,
  OFFERED: 7,
  REJECTED: 9,
  JOINED: 13,
  SELECTED: 18,
} as const;

// Type for hiring status IDs
export type HiringStatusId = typeof HIRING_STATUS_IDS[keyof typeof HIRING_STATUS_IDS];

// Centralized hiring status color mapping
export const HIRING_STATUS_COLORS: Record<HiringStatusId, string> = {
  [HIRING_STATUS_IDS.APPLIED]: colors.hiringStatusApplied,
  [HIRING_STATUS_IDS.SHORTLISTED]: colors.hiringStatusShortlisted,
  [HIRING_STATUS_IDS.INTERVIEWED]: colors.hiringStatusInterviewed,
  [HIRING_STATUS_IDS.OFFERED]: colors.hiringStatusOffered,
  [HIRING_STATUS_IDS.SELECTED]: colors.hiringStatusSelected,
  [HIRING_STATUS_IDS.JOINED]: colors.hiringStatusJoined,
  [HIRING_STATUS_IDS.REJECTED]: colors.hiringStatusRejected,
};

// Helper function to get color by status ID
export const getHiringStatusColor = (statusId: number): string => {
  return HIRING_STATUS_COLORS[statusId as HiringStatusId] || colors.chipBlue;
};

// Helper function to check if a status ID is a valid hiring status
export const isValidHiringStatus = (statusId: number): statusId is HiringStatusId => {
  return Object.values(HIRING_STATUS_IDS).includes(statusId as HiringStatusId);
};

// Backward compatibility mapping for existing code
export const hiringStatusColorMapping = HIRING_STATUS_COLORS;

// Export individual colors for direct access
export const hiringStatusColors = {
  applied: colors.hiringStatusApplied,
  shortlisted: colors.hiringStatusShortlisted,
  interviewed: colors.hiringStatusInterviewed,
  offered: colors.hiringStatusOffered,
  selected: colors.hiringStatusSelected,
  joined: colors.hiringStatusJoined,
  rejected: colors.hiringStatusRejected,
};